import { render, staticRenderFns } from "./thirdPartyLogisticsChannelsModal.vue?vue&type=template&id=0c073d6c&scoped=true"
import script from "./thirdPartyLogisticsChannelsModal.vue?vue&type=script&lang=js"
export * from "./thirdPartyLogisticsChannelsModal.vue?vue&type=script&lang=js"
import style0 from "./thirdPartyLogisticsChannelsModal.vue?vue&type=style&index=0&id=0c073d6c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c073d6c",
  null
  
)

export default component.exports